/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Kagarama 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Kanserege": ["Bwiza", "Byimana", "Ituze", "Kanserege", "Kinunga"],
  "Muyange": ["Kamuna", "Mugeyo", "Muyange", "Rugunga"],
  "Rukatsa": ["Inshuti", "Mpingayanyanza", "Nyacyonga", "Nyanza", "Rukatsa", "Taba"]
};